import { Box, Flex, styled } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";
import Arrow from "@public/images/icons/chevron-down.svg";

export const PrimaryText = styled(Text)`
  color: #040222;
`;

export const SecondaryText = styled(Text)`
  color: #5b5675;
`;

export const HyperLink = styled(Text)`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #1b73e8;
  text-align: center;

  :hover {
    cursor: pointer;
  }

  ${(props) => props.styles}
`;

export const cardStyles = ({
  show,
  styles
}: {
  show: Boolean;
  styles?: any;
}) => `
//   background-color: ${show ? "#FFFFFF" : "#F8F7FC"};


  background-color: white;
//   border: ${show ? "1px solid #E7E7F0;" : "1px solid #F8F7FC"};
  border: 1px solid #E7E7F0;
  padding-bottom: 0px;
  transition: all 0.3s cubic-bezier(0.4, 0, 1, 1) 0s;
  overflow: hidden;
  margin-top: 4px;
  @media(min-width: 768px) {
    margin-top: 8px ;
  }
  ${styles}
  `;

export const HeadingContainer = styled(Flex)`
  z-index: 0;
  width: space-between;
  justify-content: space-between
  align-items: center;
  box-sizing: border-box;
  background-color: #F9F6FF;
  padding: 1rem 1rem 0.75rem;
  position: ${(props) => (props?.showDetails ? "relative" : "")}
  ${(props) => props.styles};
`;

export const Heading = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #040222;
  @media (min-width: 768px) {
    font-size: 16px;
    line-height: 24px;
  }
`;

export const CardContent = styled(Box)`
  padding: ${(props) => (props.showDetails ? "1rem" : "0.75rem 1rem 1rem")};
  box-sizing: border-box;
`;

export const Dot = styled(Box)`
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #5b5675;
`;

export const DetailsContainer = styled(Flex)`
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export const FieldContainer = styled(Flex)`
  gap: 0.25rem;
  flex-direction: column;
  width: ${(props) => (props.renderFullWidth ? "100%" : "50%")};
`;

export const GridDetailsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);

  row-gap: 20px;
`;

export const GridFieldContainer = styled(Flex)`
  flex-direction: column;
  gap: 0.25rem;
`;

export const GridItem = styled.div`
  ${(props) => props.fullWidth && `grid-column: 1 / span 2;`}
`;

export const FieldName = styled(SecondaryText)`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;

export const FieldValue = styled(PrimaryText)`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;

export const Divider = styled(Box)`
  height: 1px;
  background-color: #e7e7f0;
  margin: 1rem 0px;
`;

export const EditCta = styled(HyperLink)`
  text-align: left;
`;

export const StyledArrow = styled(Arrow)`
  margin-left: 0.68rem;
  transform: ${(props) => (props.show ? "rotate(180deg)" : "rotate(0deg)")};
  transition: transform 0.3s ease;

  :hover {
    cursor: pointer;
  }
`;

export const MinifiedDetailsValue = styled.div`
  color: #5b5675;
  font-size: 0.875rem;
  width: max-content;
  font-weight: ${(props) => (props?.emphasize ? "600" : "400")};
`;

export const EditSection = styled.div`
  display: flex;
  justify-content: left;
  align-items: center;
  gap: 0.5rem;
  border-radius: 0px 0px 12px 12px;
  cursor: pointer;
`;
